import i18n from 'i18next'

export const getPlatformLabel = (bundle: string) => {
  if (bundle.includes('ios')) {
    return i18n.t('common.iosApp')
  }
  if (bundle.includes('android')) {
    return i18n.t('common.androidApp')
  }

  return i18n.t('common.desktop')
}
